// hooks/useOperators.js
import { useState, useEffect } from "react";
import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";


export const useOperators = (isOperatorDataLoaded) => {
    const [operators, setOperators] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchOperators = async () => {
        setLoading(true);
        setError(null);

        try {
            const para = {
                p_companyid: localStorage.getItem("companyid"),
                p_plantid: 1,
            };

            const data = await callApi(
                API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR,
                "POST",
                { "Content-Type": "application/json" },
                para
            );

            if (data && data.length > 0) {
                setOperators(data);
                setSelectedOperator(data[0]);
            } else {
                setOperators([]);
            }
        } catch (err) {
            setError(err);
            console.error("Error fetching operators:", err.message);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (isOperatorDataLoaded) return;
        fetchOperators();
    }, [isOperatorDataLoaded]);

    const refreshOperator = () => {
        fetchOperators();
    }

    return { operators, selectedOperator, setSelectedOperator, loading, error,  };
};
